'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var Footer = require('@narvar/nth-bundle-narvar-footer');
var Button = require('@narvar/nth-block-button');
var style = require('../../utils/style.js');
var nthHookTheme = require('@narvar/nth-hook-theme');
var ActionButtonsContainer = require('./ActionButtonsContainer.js');
var useIsMobile = require('../../providers/useIsMobile.js');
var SecondaryButton = require('../SecondaryButton.js');
var Header = require('./Header.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var Footer__default = /*#__PURE__*/_interopDefaultLegacy(Footer);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);

const PageWrapperStyled = styled__default["default"].div.withConfig({
  componentId: "sc-1tp0i3x-0"
})(_ref => {
  let {
    showFooterActions
  } = _ref;
  return {
    display: 'flex',
    flexDirection: 'column',
    ...(showFooterActions ? {
      height: '100dvh'
    } : {
      minHeight: '100dvh'
    })
  };
});
const PageBody = styled__default["default"].div.withConfig({
  componentId: "sc-1tp0i3x-1"
})(_ref2 => {
  let {
    stickyFooter
  } = _ref2;
  return {
    boxSizing: 'border-box',
    overflow: stickyFooter ? 'scroll' : undefined,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    flex: '1 0 0',
    paddingTop: '1.5rem'
  };
});
const PageInner = styled__default["default"].div.withConfig({
  componentId: "sc-1tp0i3x-2"
})(["padding:0 2rem;box-sizing:border-box;width:100%;max-width:49.5rem;margin:0 auto;"]);
const FooterWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-1tp0i3x-3"
})(["padding-top:2rem;"]);
const PageWrapper = _ref3 => {
  let {
    children,
    hero,
    footerActions,
    stickyFooter
  } = _ref3;
  const {
    panelcontainerNoneNone
  } = nthHookTheme.useTheme();
  const isMobile = useIsMobile["default"]();
  return /*#__PURE__*/React__default["default"].createElement(PageWrapperStyled, {
    showFooterActions: Boolean(footerActions === null || footerActions === void 0 ? void 0 : footerActions.length)
  }, /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(Header["default"], null)), hero, /*#__PURE__*/React__default["default"].createElement(PageBody, {
    stickyFooter: stickyFooter
  }, /*#__PURE__*/React__default["default"].createElement(PageInner, null, children)), !(footerActions !== null && footerActions !== void 0 && footerActions.length) && /*#__PURE__*/React__default["default"].createElement(PageInner, null, /*#__PURE__*/React__default["default"].createElement(FooterWrapper, null, /*#__PURE__*/React__default["default"].createElement(Footer__default["default"], {
    hack_paddingOverride: "padding: 1rem 0 2rem 0"
  }))), (footerActions === null || footerActions === void 0 ? void 0 : footerActions.length) && /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      borderTopWidth: style.getBorderWidth(panelcontainerNoneNone),
      borderTopColor: style.getBorderColor(panelcontainerNoneNone),
      borderTopStyle: 'solid',
      padding: '1rem',
      width: '100%',
      boxSizing: 'border-box',
      ...(!isMobile && {
        display: 'flex',
        justifyContent: 'center'
      })
    }
  }, /*#__PURE__*/React__default["default"].createElement(ActionButtonsContainer["default"], null, footerActions.map((_ref4, i) => {
    let {
      type,
      action,
      content,
      disabled
    } = _ref4;
    return type === 'secondary' ? /*#__PURE__*/React__default["default"].createElement(SecondaryButton["default"], {
      big: isMobile,
      onClick: action,
      disabled: disabled || undefined,
      key: i
    }, content) : /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      big: isMobile,
      onClick: action,
      disabled: disabled || undefined,
      key: i
    }, content);
  }))));
};
var PageWrapper$1 = nthHookTheme.withThemeProvider(PageWrapper, {
  themeTokens: ['panelcontainerNoneNone']
});

exports["default"] = PageWrapper$1;
